import {
    SuccessResponseDto, FindAllByDto, VehicleSearchDto,
    FindVehicleAutocompleteDto, CreateVehicleDto, UpdateVehicleDto,
    HistoricResponseDto, SearchHistoricDto, HistoricDetailsResponseDto, SearchVehicleDto,
    FilterByIdsDto,

} from "@/dtos";
import { Vehicle } from "@/entities";
import http from '@/helpers/apis/http-fleet';
import { validateToken } from "@/helpers/utilities";
import { authHeader } from "@/helpers/utilities/auth-header";

class VehicleService {
    async create(vehicleDto: CreateVehicleDto): Promise<SuccessResponseDto<Vehicle>> {
        await validateToken();
        const result = await http.post('/admin/vehicles/create', vehicleDto, {
            headers: authHeader(), withCredentials: true
        });
        return result.data;
    }

    async findAllRelation(params?: FindAllByDto): Promise<SuccessResponseDto<Vehicle[]>> {
        await validateToken();
        const result = await http.get('/admin/vehicles/all-relation',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            });
        return result.data;
    }

    async findAllExport(searchDto: SearchVehicleDto): Promise<SuccessResponseDto<Vehicle[]>> {
        await validateToken();
        const result = await http.get('/admin/vehicles/all-export',
            {
                params: searchDto,
                headers: authHeader(),
                withCredentials: true
            });
        return result.data;
    }

    async findByIds(params: FilterByIdsDto): Promise<SuccessResponseDto<Vehicle[]>> {
        await validateToken();
        const result = await http.get('/admin/vehicles/by-ids',
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            });
        return result.data;
    }

    async findAllAutocomplete(params: FindVehicleAutocompleteDto): Promise<SuccessResponseDto<Vehicle[]>> {
        await validateToken();
        const result = await http.get(`/admin/vehicles/all-autocomplete`,
            { params: params, headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async findOne(vehicle_id: number): Promise<SuccessResponseDto<Vehicle>> {
        await validateToken();
        const result = await http.get(`/admin/vehicles/${vehicle_id}`,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async findByCompany(id_company?: number): Promise<SuccessResponseDto<Vehicle[]>> {
        await validateToken();
        const result = await http.get(`/admin/vehicles/all-by-company`, {
            params: { id_company }, headers: authHeader(), withCredentials: true
        });
        return result.data;
    }

    async search(searchDto: SearchVehicleDto): Promise<SuccessResponseDto<VehicleSearchDto>> {
        await validateToken();
        const result = await http.get(`/admin/vehicles/search`, {
            params: searchDto, headers: authHeader(), withCredentials: true
        });
        return result.data;
    }

    async getHistoric(id: number): Promise<SuccessResponseDto<HistoricResponseDto>> {
        await validateToken();
        const result = await http.get(`/admin/vehicles/historic/${id}`,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }

    async getHistoricDetails(params: SearchHistoricDto): Promise<SuccessResponseDto<HistoricDetailsResponseDto[]>> {
        await validateToken();
        const result = await http.get(`/admin/vehicles/historic-details`,
            {
                params: params,
                headers: authHeader(),
                withCredentials: true
            }
        );
        return result.data;
    }


    async update(idVehicle: number, vehicleDto: UpdateVehicleDto): Promise<SuccessResponseDto<Vehicle>> {
        await validateToken();
        const result = await http.patch(`/admin/vehicles/update/${idVehicle}`, vehicleDto,
            { headers: authHeader(), withCredentials: true }
        );
        return result.data;
    }
}

export default new VehicleService;